import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"min-height":"60vh"} }

import { onMounted } from "vue";
import FooterComponent from "./components/FooterComponent.vue";
import HeaderComponent from "./components/HeaderComponent.vue";
import { store } from "./utils/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  store.isMobile = screen.width < 768;
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_el_backtop = _resolveComponent("el-backtop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterView),
      _createVNode(_component_el_backtop, {
        right: 50,
        bottom: 100,
        "visibility-height": 300
      })
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})